import { IFRMParams } from "../Controls/FormParameters";
import { IWindowable } from "../UIManagerInterfaces";
import { FormResult } from "./Forms/FormResult";

/**
 * Varianta IWindowable s parametric data typovanými na IFRMParameters.
 * IFRMParameters nemohou být součástí IWindowable jako takového, protože je využívána
 * reactovou částí aplikace, se kterou není IFRMParameters kompatibilní. Problém s kompatibilitou
 * může být strict mód a případně cyklické závislosti.
 */
export interface IWindowableWithIFRMParams extends IWindowable {
    setParametricData(parametricData: IFRMParams): void;
}

export enum ModalWindowType {
    parametricForm,
    lov,
    errorMsg,
    modalForm,
}

export interface IModalWindowConfiguration {
    resizeable: boolean;
    showFooter: boolean;
    showHeader: boolean;
    closeAble?: boolean;
}

/**
 * Nastavení pro zobrazení modálního okna
 * @includeToDoc
 */
export interface IShowModalParams {
    /** Okno, které má být zobrazeno */
    readonly window: IWindowableWithIFRMParams;
    /** Typ modálního okna */
    readonly type: ModalWindowType;
    /** Metoda provedena při zavření modálního okna */
    onClose?: (sender?: IWindowable, result?: FormResult) => void;
    /** Příznak, jestli se má zobrazit overlay vrstva */
    readonly showOverlay?: boolean;
    /** Konfigurace modální okna */
    modalConfig?: IModalWindowConfiguration;
    /** Příznak jestli se má zobrazit v drobečkové navigaci */
    readonly showBreadcrumbNav?: boolean;
}
